import { KeyValuePipe, NgClass, NgFor, NgIf } from '@angular/common';
import { Component } from '@angular/core';

import { ShortTeamNamesService } from '@frontend/sports/betting-offer/feature/short-team-names';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';

import { BettingInsightsComponentLoaderService } from '../betting-insights/betting-insights-component-loader.service';
import { BetBuilderOptionComponent } from './bet-builder-option.component';
import { MarketHelpComponent } from './market-help/market-help.component';
import { OptionGroup, OptionGroupService } from './option-group.service';
import { ISixPackOptionRow, SixPackOptionGroupComponent } from './six-pack-option-group.component';

@Component({
    selector: 'ms-bet-builder-six-pack',
    templateUrl: './bet-builder-six-pack.component.html',
    standalone: true,
    imports: [NgIf, NgFor, NgClass, KeyValuePipe, MarketHelpComponent, BetBuilderOptionComponent],
})
export class BetBuilderSixPackComponent extends SixPackOptionGroupComponent {
    private maxParticipants = 2;

    constructor(
        sitecore: Sitecore,
        optionGroupService: OptionGroupService,
        shortTeamNamesService: ShortTeamNamesService,
        loader: BettingInsightsComponentLoaderService,
    ) {
        super(sitecore, optionGroupService, shortTeamNamesService, loader);
    }

    protected override getOptionRows(optionGroups: OptionGroup[]): ISixPackOptionRow[] {
        return [...Array(this.maxParticipants)].map((value, index) => ({
            player: '',
            columns: this.getOptionRowColumns(optionGroups, (options) => options[index]),
        }));
    }

    protected override getTupleClass(): string {
        const colCount = this.optionRows.length > 0 ? this.optionRows[0].columns.size : 0;
        switch (colCount) {
            case 2:
                return 'double';
            case 3:
                return 'triple';
            case 4:
                return 'quadruple';
            default:
                return '';
        }
    }
}
